module.exports = __webpack_public_path__ + "img/CIAZ2021.cbf89284.png";